module.exports = __webpack_public_path__ + "639f085feaabcba03c612df85198f21f.svg";